import { api } from "../../utills/api";

export const balanceApi = api.injectEndpoints({
  endpoints: (build) => ({
    getBalanceSummary: build.mutation<any, any>({
      query: (params) => ({
        url: "/merchant/balanceSummary",
        body: params,
        method: "POST",
      }),
    }),
  }),
});

export const { useGetBalanceSummaryMutation } = balanceApi;
export const {
  endpoints: { getBalanceSummary },
} = balanceApi;
